import React from "react";

const SendBtn = ({ label, style }) => {
  return (
    <button
      type="submit"
      className="w-full py-2 text-white font-bold rounded-full transition"
      style={style}
    >
      {label}
    </button>
  );
};

export default SendBtn;
